export enum SkyAccess_IFrame{
    GENERAL_SETTINGS = 'general-settings-IFrame',
    BUSINESS_SETTINGS = 'business-settings-IFrame',
    WELCOME_PAGE = 'welcome-page-IFrame',
    BUSINESS_LISTS = 'business-lists-IFrame',
    BUSINESS_DETAILS = 'business-details-IFrame',
    DEFAULT = 'myFrame'
}